import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {Container, Nav, NavItem, NavLink, Row} from "reactstrap";

const AttachmentModalHeader = (props) => {

    const publishedContentClassNames = classnames({
        active: props.activeTab === "published-content",
        "cursor-pointer": true
    });

    const myLibraryClassNames = classnames({
        active: props.activeTab === "my-library",
        "cursor-pointer": true
    });

    const pcClassNames = classnames({
        active: props.activeTab === "pc",
        "cursor-pointer": true
    });


    return (
        <Nav tabs className="availability-requests" style={{marginLeft:-20}}>
            <NavItem className="ml-md-4">
                <NavLink
                    className={publishedContentClassNames}
                    onClick={() => props.toggle("published-content")}>
                    Published content
                </NavLink>
            </NavItem>
            <NavItem className="ml-md-4">
                <NavLink
                    className={myLibraryClassNames}
                    onClick={() => props.toggle("my-library")}>
                    My Library
                </NavLink>
            </NavItem>
            {/*<NavItem className="ml-md-4">*/}
            {/*    <NavLink*/}
            {/*        className={pcClassNames}*/}
            {/*        onClick={() => props.toggle("pc")}>*/}
            {/*        Upload from my PC*/}
            {/*    </NavLink>*/}
            {/*</NavItem>*/}
        </Nav>
    )
};

AttachmentModalHeader.propTypes = {
    activeTab: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
};


export default AttachmentModalHeader;